module.exports = __webpack_public_path__ + "img/b634752.png";